<template>
  <div
      :id="groupId + '-' + itemID"
      class="bg-white border border-blue-200 rounded accordion-item hover:bg-blue-100"
      :class="{ 'is-active': item.active }"
  >
    <dt class="relative accordion-item-title">
      <button @click="toggle" class="flex items-center w-full py-5 text-left pl-7 pr-14 " :class="[item.active ? 'text-blue-700' : 'text-blue-500']">
        <span class="block font-bold  text-b1"> {{item.title}}</span>
        <svg viewBox="0 0 24 25" fill="none" stroke="#BCD9E2" stroke-width="2" stroke-linecap="butt" stroke-linejoin="bevel" class="absolute w-6 h-6 right-6 icon icon-plus">
          <path d="M12 20V6M6"></path>
          <line x1="4" y1="13" x2="20" y2="13"></line>
        </svg>
      </button>
    </dt>
    <transition
        name="accordion-item"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
    >
      <dd v-if="item.active" class="overflow-hidden">
        <div v-if="item.content" v-html="item.content" class="px-8 mb-8 text-left text-blue-700 wyswyg"></div>
      </dd>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      type: Number,
      default: 1,
    },
    itemID: {
      type: Number,
      default: 1,
    },
    item: {
      type: Object,
      default: ()=>{},
    },
    multiple: {
      type: Boolean,
      default: ()=>{},
    },
  },
  methods: {
    toggle(event) {
      if (this.multiple) {
        this.item.active = !this.item.active;
      } else {
        this.$parent.$children.forEach((item, index) => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) {
            item.item.active = !item.item.active;
          } else {
            item.item.active = false;
          }
        });
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>
<style  >
.icon-plus {
  transition: all 0.7s;
  transform-origin: center center;
}
.is-active{
  @apply border-transparent bg-blue-100 text-blue-700;
}
.is-active .icon {
  transform-origin: center center;
  transform: rotate(180deg);
  stroke: #005B78;
}
.is-active .icon path {
  @apply opacity-0;
}

.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}

.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
</style>
